import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from '../api/axios';
import { toast } from 'react-toastify';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const ORANGE = '#f57c00';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post('/auth/login', { email, password });
      const userData = res.data;

      login(userData);
      toast.success('Login successful!');

      const role = userData?.role ?? userData?.user?.role;
      if (role === 'super_admin')  navigate('/dashboard');
      else if (role === 'system_admin')  navigate('/dashboard');
      else if (role === 'tca')      navigate('/test-center');  // ✅ FIXED: 'tca' not 'test_center_admin'
      else if (role === 'invigilator') navigate('/invigilator');
      else navigate('/dashboard');

    } catch (err) {
      toast.error(err.response?.data?.message );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: 'linear-gradient(135deg, #fff3e0, #ffe0b2)'
    }}>
      <div style={{
        backgroundColor: 'white', padding: '40px', borderRadius: '14px',
        boxShadow: '0 6px 20px rgba(0,0,0,0.1)', width: '100%',
        maxWidth: '420px', borderTop: `5px solid ${ORANGE}`
      }}>
        <h2 style={{ textAlign: 'center', color: ORANGE, marginBottom: '8px', fontWeight: 800 }}>
          ORC System
        </h2>
        <p style={{ textAlign: 'center', color: '#666', marginBottom: '30px', fontSize: '14px' }}>
          Online Exam Remuneration Calculator
        </p>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '6px', fontSize: '14px' }}>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              placeholder="Enter your email"
              style={{ width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '8px', outline: 'none' }}
            />
          </div>
          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', marginBottom: '6px', fontSize: '14px' }}>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              placeholder="Enter your password"
              style={{ width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '8px', outline: 'none' }}
            />
          </div>
          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '12px', backgroundColor: ORANGE, color: 'white',
            border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: 600,
            cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1
          }}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;